import { Container } from 'react-bootstrap';
import { getImagenURL } from '../Utils/Imagen';
export default function ImagenSola({ data: { id, props: { backgroundColor, fluid, img, aspectRatio = 16 / 7.2 } } }: any) {
    return <div style={{ padding: fluid ? '0 0 0 0' : '60px 0', background: backgroundColor }}>
        {fluid ? <img style={{ aspectRatio }} src={getImagenURL(img)} width='100%' alt={`sola ${id}`} /> : <Container>
            <img style={{ aspectRatio }} src={getImagenURL(img)} width='100%' alt={`sola ${id}`} />
        </Container>}
    </div>
}
